/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerUpdatePriorityMutationRequest,
  UserFlagsModeratorControllerUpdatePriorityMutationResponse,
  UserFlagsModeratorControllerUpdatePriorityPathParams,
  UserFlagsModeratorControllerUpdatePriority401,
  UserFlagsModeratorControllerUpdatePriority404,
} from '../types/UserFlagsModeratorControllerUpdatePriority.ts';

function getUserFlagsModeratorUpdatePriorityUrl(id: UserFlagsModeratorControllerUpdatePriorityPathParams['id']) {
  const res = { method: 'PATCH', url: `/api/moderator/user-flags/priority/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags/priority/:id}
 */
export async function userFlagsModeratorUpdatePriority(
  id: UserFlagsModeratorControllerUpdatePriorityPathParams['id'],
  data: UserFlagsModeratorControllerUpdatePriorityMutationRequest,
  config: Partial<RequestConfig<UserFlagsModeratorControllerUpdatePriorityMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserFlagsModeratorControllerUpdatePriorityMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerUpdatePriority401 | UserFlagsModeratorControllerUpdatePriority404>,
    UserFlagsModeratorControllerUpdatePriorityMutationRequest
  >({
    method: 'PATCH',
    url: getUserFlagsModeratorUpdatePriorityUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
